var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJob({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/job"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.948 4.458V3.11c0-.75-.578-1.36-1.29-1.36h-3.315c-.713 0-1.29.61-1.29 1.36v1.348m5.895 0H9.052m5.896 0h4.27c1.122 0 2.032.97 2.032 2.167v5.417h-.659M9.052 4.458H4.783c-1.123 0-2.033.97-2.033 2.167v5.417h.639m17.202 0h-6.314m6.314 0 .061 7.041c0 1.197-.91 2.167-2.033 2.167H5.381c-1.123 0-2.033-.97-2.033-2.167l.04-7.041m10.889 0v-.652c0-.626-.481-1.134-1.075-1.134H10.88c-.594 0-1.076.508-1.076 1.134v.652m4.473 0v.764c0 .626-.481 1.134-1.075 1.134H10.88c-.594 0-1.076-.508-1.076-1.134v-.764m0 0H3.39",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJob);
export default __webpack_public_path__ + "static/media/job.156c549a242490f7302d6600a961d602.svg";
export { ForwardRef as ReactComponent };